"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagNA = function FlagNA(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,82.8V-114.94a7.06,7.06,0,0,1,7.06-7.06H117.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-58.44V139.3a7.07,7.07,0,0,1-7.06,7.06H-94.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-54.46v-60.48a7.06,7.06,0,0,0-7.06-7.06h-96L-193,78.82V139.3a7.07,7.07,0,0,0,7.06,7.06h96Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-79.78v-35.16a7.06,7.06,0,0,0-7.06-7.06H152.16L-193,104.14V139.3a7.06,7.06,0,0,0,7.06,7.06h57.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-120.84-75.91A25.13,25.13,0,0,1-103-68.54l2.5-17.34L-114.32-75l-6.52-16.28L-127.35-75l-13.79-10.84,2.5,17.34a25.12,25.12,0,0,1,17.8-7.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-138.65-32.91A25.11,25.11,0,0,1-146-50.72a25.08,25.08,0,0,1,7.37-17.8L-156-71l10.85,13.79-16.29,6.51,16.29,6.52L-156-30.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.23-50.72l-16.29-6.51L-85.67-71-103-68.52a25.08,25.08,0,0,1,7.37,17.8A25.11,25.11,0,0,1-103-32.91l17.35,2.5L-96.52-44.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-120.84-25.53a25.08,25.08,0,0,1-17.8-7.37l-2.5,17.35,13.79-10.85,6.52,16.29,6.51-16.29,13.79,10.85L-103-32.9a25.09,25.09,0,0,1-17.81,7.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-100.27-50.72a20.56,20.56,0,0,1-20.56,20.57A20.57,20.57,0,0,1-141.4-50.72a20.57,20.57,0,0,1,20.57-20.56,20.56,20.56,0,0,1,20.56,20.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagNA;
exports["default"] = _default;